import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Pictures from './pages/Pictures';
import Admin from './pages/Admin';
import BusinessCard, { CardCapture } from './pages/BusinessCard';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { initGA, trackPageView } from './utils/analytics';

// Component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pictures" element={<Pictures />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/card" element={<BusinessCard />} />
          <Route path="/card/capture" element={<CardCapture />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;